/**
 * @generated SignedSource<<4aedaa1d2acd1f6b9be92badaf7263c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiskCleanerInput = {
  media?: DiskCleanerMediaInput | null;
  storage?: DiskCleanerStorageInput | null;
};
export type DiskCleanerMediaInput = {
  selected?: boolean | null;
};
export type DiskCleanerStorageInput = {
  selected?: boolean | null;
};
export type DiskCleanupMediaRefetchQuery$variables = {
  input?: DiskCleanerInput | null;
  scan: boolean;
};
export type DiskCleanupMediaRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupMedia_data">;
};
export type DiskCleanupMediaRefetchQuery = {
  response: DiskCleanupMediaRefetchQuery$data;
  variables: DiskCleanupMediaRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scan"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiskCleanupMediaRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DiskCleanupMedia_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiskCleanupMediaRefetchQuery",
    "selections": [
      {
        "condition": "scan",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "DiskCleanerResult",
            "kind": "LinkedField",
            "name": "diskCleanerScan",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CleanInfo",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "size",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8bc2cd8058c8e46457581506b32d60ae",
    "id": null,
    "metadata": {},
    "name": "DiskCleanupMediaRefetchQuery",
    "operationKind": "query",
    "text": "query DiskCleanupMediaRefetchQuery(\n  $input: DiskCleanerInput\n  $scan: Boolean!\n) {\n  ...DiskCleanupMedia_data\n}\n\nfragment DiskCleanupMedia_data on Query {\n  diskCleanerScan(input: $input) @include(if: $scan) {\n    media {\n      ...DiskCleanupResult_cleanInfo\n    }\n  }\n}\n\nfragment DiskCleanupResult_cleanInfo on CleanInfo {\n  ...DiskCleanupScanInfo_scanInfo\n}\n\nfragment DiskCleanupScanInfo_scanInfo on CleanInfo {\n  count\n  size\n}\n"
  }
};
})();

(node as any).hash = "976f6c54f1189134de6a06f7b1c43c34";

export default node;
